import { Input } from "@/components/ui/input";
import { DateInputIT } from "@/components/DateInputIT";
import { RubricaPicker } from "@/components/sinistri/RubricaPicker";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { UserCog, Phone, Mail } from "lucide-react";

const RUOLI = [
  { key: "perito", label: "Perito" },
  { key: "liquidatore", label: "Liquidatore" },
  { key: "legale", label: "Legale" },
];
const CAMPI = [
  { k: "nome", l: "Nome e cognome" }, { k: "studio", l: "Studio / società" },
  { k: "telefono", l: "Telefono", t: "tel" }, { k: "email", l: "Email", t: "email" },
  { k: "pec", l: "PEC", t: "email" }, { k: "data_incarico", l: "Data incarico", t: "date" },
];

const Riepilogo = ({ v }) => (v?.nome ? (
  <span className="text-[11px] text-slate-500 truncate flex items-center gap-2">
    {v.telefono && <span className="flex items-center gap-0.5"><Phone className="h-3 w-3" />{v.telefono}</span>}
    {v.email && <span className="flex items-center gap-0.5"><Mail className="h-3 w-3" />{v.email}</span>}
  </span>
) : null);

export const SinistroIncaricati = ({ s, setF }) => {
  const upd = (ruolo, k, val) => setF(ruolo, { ...(s[ruolo] || {}), [k]: val });
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-testid="sin-incaricati-card">
      <h3 className="font-heading text-lg text-slate-900 mb-1 flex items-center gap-2"><UserCog className="h-4 w-4" /> Incaricati</h3>
      <p className="text-sm text-slate-500 mb-3">Perito, liquidatore e legale incaricati. Scegli dalla rubrica o inserisci a mano: al Salva i nuovi nominativi entrano in rubrica.</p>
      <Tabs defaultValue="perito">
        <TabsList className="mb-3">
          {RUOLI.map((r) => (
            <TabsTrigger key={r.key} value={r.key} data-testid={`sin-inc-tab-${r.key}`}>
              {r.label}{s[r.key]?.nome ? <span className="ml-1.5 h-1.5 w-1.5 rounded-full bg-emerald-500" /> : null}
            </TabsTrigger>
          ))}
        </TabsList>
        {RUOLI.map((r) => (
          <TabsContent key={r.key} value={r.key} className="space-y-3">
            <RubricaPicker ruolo={r.key} onPick={(x) => setF(r.key, { ...(s[r.key] || {}), nome: x.nome, studio: x.studio, telefono: x.telefono, email: x.email, pec: x.pec })} />
            <Riepilogo v={s[r.key]} />
            <div className="grid grid-cols-2 gap-3">
              {CAMPI.map((c) => (
                <div key={c.k} className="space-y-1.5"><Label className="text-sm text-slate-600">{c.l}</Label>
                  {c.t === "date"
                    ? <DateInputIT value={s[r.key]?.[c.k] || ""} onChange={(v) => upd(r.key, c.k, v)} testid={`sin-inc-${r.key}-${c.k}`} />
                    : <Input type={c.t || "text"} value={s[r.key]?.[c.k] || ""} onChange={(e) => upd(r.key, c.k, e.target.value)} data-testid={`sin-inc-${r.key}-${c.k}`} />}</div>
              ))}
              <div className="col-span-2 space-y-1.5"><Label className="text-sm text-slate-600">Note</Label>
                <Textarea rows={2} value={s[r.key]?.note || ""} onChange={(e) => upd(r.key, "note", e.target.value)} data-testid={`sin-inc-${r.key}-note`} /></div>
            </div>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
};
